import { Maybe } from 'aem-libs-ts/src/types/utility'

import { GroupBy, GroupedItems } from '../types'

export const useGroupedItems = <TOption>(
  renderedItems: TOption[],
  groupBy: Maybe<GroupBy<TOption>>
): GroupedItems<TOption> | null => {
  if (!groupBy) {
    return null
  }

  return renderedItems.reduce((acc, curr) => {
    const groupName = groupBy(curr) as keyof typeof acc
    if (!acc[groupName]) {
      acc[groupName] = [curr]
    } else {
      acc[groupName] = [...(acc[groupName] as TOption[]), curr]
    }

    return acc
  }, {} as GroupedItems<TOption>)
}
